import { parseRoutingFromEnv, resolveWriteRepo } from './writeRouting';

export class CompositeListingRepository {
  constructor({ firestoreRepo, apiRepo, writeRouting = {} }) {
    this.firestoreRepo = firestoreRepo;
    this.apiRepo = apiRepo;
    this.writeRouting = {
      defaultTarget: writeRouting.defaultTarget || 'firestore',
      operationTargets: writeRouting.operationTargets || {}
    };
  }

  writeRepoFor(operation) {
    return resolveWriteRepo({
      routing: this.writeRouting,
      operation,
      firestoreRepo: this.firestoreRepo,
      apiRepo: this.apiRepo,
      scopeName: 'ListingRepository'
    });
  }

  listingsSearch(city, options = {}) {
    return this.firestoreRepo.listingsSearch(city, options);
  }

  searchListings(cityId, options) {
    return this.apiRepo.searchListings(cityId, options);
  }

  exportListings(cityId, options) {
    return this.apiRepo.exportListings(cityId, options);
  }

  updateListingStatus(cityId, listingId, payload) {
    return this.writeRepoFor('updateListingStatus').updateListingStatus(cityId, listingId, payload);
  }
}

export function getListingWriteRoutingFromEnv(env = process.env) {
  const routing = parseRoutingFromEnv({
    env,
    defaultTargetKeys: [
      'VUE_APP_LISTING_WRITE_REPOSITORY',
      'VUE_APP_CITY_WRITE_REPOSITORY',
      'VUE_APP_CITY_WRITE_TARGET'
    ],
    operationTargetsKeys: [
      'VUE_APP_LISTING_WRITE_REPOSITORY_BY_OPERATION',
      'VUE_APP_CITY_WRITE_REPOSITORY_BY_OPERATION'
    ]
  });

  // Status changes require backend side effects and cannot fall back to direct Firestore writes.
  routing.operationTargets.updateListingStatus = 'api';

  return routing;
}
